import React from 'react';

import Dispatcher from './dispatcher.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleStream}
 */
const Stream = ({
    borderTop = true,
    classes= null,
    modules= null,
    namespace= null,
    ...props
}) => {
    return (
        <>
            {modules?.map((module, idx) => (
                <Dispatcher
                    borderTop={idx === 0 ? borderTop : undefined}
                    classes={classes}
                    index={idx}
                    key={`${(namespace ?? '')}-module-${idx}`}
                    module={module}
                    moduleNextType={modules?.[idx + 1]?.__typename}
                    modulePreviousType={modules?.[idx - 1]?.__typename}
                    namespace={`${(namespace ?? '')}-module-${idx}`}
                    {...props} />
            ))}
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

Stream.displayName = 'ModuleStream';

export default Stream;
